import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const AppsDevelopment = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Mobile App Development</h6>
          <hr />
          <h1 className="banner-title">
            Empower Growth with <br /> Custom Mobile App Development Solutions
          </h1>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="./assets/img/3008.png"
          alt="Banner Background"
          className="banner-image"
        />
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-8">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell">Mobile App Development</h6>
                <h2 className="mt-3 mb-3">
                  Transforming Ideas into Powerful Mobile Solutions
                </h2>
                <p>
                  At <strong>Datafluent Analytics</strong>, we specialize in
                  creating custom mobile apps that drive business growth. From
                  startups to enterprises, we provide scalable, secure, and
                  user-friendly applications tailored to meet your unique needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our-approach">
        <h2 className="approach-title">Our Mobile App Development Approach</h2>
        <div className="approach-container">
          <div className="approach-step">
            <i className="fa fa-mobile-alt fa-3x" aria-hidden="true"></i>
            <h3>Understand Your Requirements</h3>
            <p>
              We start by analyzing your business needs and defining key app
              functionalities.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-cogs fa-3x" aria-hidden="true"></i>
            <h3>Custom App Design</h3>
            <p>
              We design tailored user interfaces and user experiences based on
              your brand and goals.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-laptop-code fa-3x" aria-hidden="true"></i>
            <h3>App Development</h3>
            <p>
              Our development team uses the latest technologies to build
              high-performance apps.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-sync-alt fa-3x" aria-hidden="true"></i>
            <h3>Cross-Platform Solutions</h3>
            <p>
              We ensure your app works seamlessly on both iOS and Android
              platforms, maximizing reach.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-clipboard-list fa-3x" aria-hidden="true"></i>
            <h3>Testing & Quality Assurance</h3>
            <p>
              We rigorously test the app to ensure it meets high standards of
              performance and security.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-rocket fa-3x" aria-hidden="true"></i>
            <h3>Launch & Support</h3>
            <p>
              We help launch your app on app stores and provide ongoing support
              and updates.
            </p>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-fluid" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4 text-center">
            <div className="col-md-12">
              <div className="serv_h1l">
                <h3>Our Technology</h3>
                <p className="mb-0">Technologies and tools we specialize in</p>
              </div>
            </div>
          </div>

          <div className="my-swiper-container">
            <Swiper
              modules={[]}
              spaceBetween={16}
              loop={true}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
              }}
            >
              {/* React.js */}
              <SwiperSlide>
                <img
                  src="https://logos-world.net/wp-content/uploads/2022/07/Java-Logo-700x394.png"
                  alt="React.js"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* python */}
              <SwiperSlide>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Google-flutter-logo.svg/768px-Google-flutter-logo.svg.png"
                  alt="python"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Vue.js */}
              <SwiperSlide>
                <img
                  src="https://cdn.icon-icons.com/icons2/2699/PNG/512/reactjs_logo_icon_170805.png"
                  alt="Vue.js"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Angular */}
              <SwiperSlide>
                <img
                  src="https://logowik.com/content/uploads/images/swift.jpg"
                  alt="Angular"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Docker */}
              <SwiperSlide>
                <img
                  src="https://i.pinimg.com/originals/ac/0b/71/ac0b718d995deda3e1e4ee893501324d.png"
                  alt="Docker"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>
            </Swiper>

            <div className="my-swiper-button-prev"></div>
            <div className="my-swiper-button-next"></div>
          </div>
        </div>
      </section>

      <hr />

      <section class="bg-light">
        <div class="container-fluid" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4">
            <div className="col-md-9">
              <div className="serv_h1l">
                <h3>Services We're Offering</h3>
                <p className="mb-0">
                  Custom software solutions to drive business growth
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-university me-3 fs-4 text-black"></i>
              <Link
                to="/banking"
                className="text-decoration-none text-dark fs-5"
              >
                Banking
              </Link>
            </div>

            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-graduation-cap me-3 fs-4 text-black"></i>
              <Link
                to="/education"
                className="text-decoration-none text-dark fs-5"
              >
                Education
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-hospital me-3 fs-4 text-black"></i>
              <Link
                to="/healthcare"
                className="text-decoration-none text-dark fs-5"
              >
                Healthcare
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-shield-alt me-3 fs-4 text-black"></i>
              <Link
                to="/insurance"
                className="text-decoration-none text-dark fs-5"
              >
                Insurance
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-industry me-3 fs-4 text-black"></i>
              <Link
                to="/manufacturing"
                className="text-decoration-none text-dark fs-5"
              >
                Manufacturing
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-shopping-cart me-3 fs-4 text-black"></i>
              <Link
                to="/retail"
                className="text-decoration-none text-dark fs-5"
              >
                Retail
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-chart-line me-3 fs-4 text-black"></i>
              <Link
                to="/capital-markets"
                className="text-decoration-none text-dark fs-5"
              >
                Capital Markets
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-box me-3 fs-4 text-black"></i>
              <Link
                to="/consumer-goods"
                className="text-decoration-none text-dark fs-5"
              >
                Fast-Moving Consumer Goods (FMCG)
              </Link>
            </div>

            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-users me-3 fs-4 text-black"></i>
              <Link
                to="/public-services"
                className="text-decoration-none text-dark fs-5"
              >
                Public Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="bi-cta" className="bi-cta text-center py-5">
    <h3>Ready to Transform Your Business with BI?</h3>
    <p>Contact us today to learn how Business Intelligence can unlock your company's potential.</p>
    <a href="#contact" className="btn btn-success mt-3">Get Started</a>
  </section> */}

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div
            className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4"
            style={{ backgroundColor: "#343a40", color: "white" }}
          >
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="text-white">
                  Build the Future with Your Next Mobile App!
                </h2>
                <p className="text-white mt-3">
                  Let’s discuss how custom mobile app development can boost your
                  business and enhance customer engagement.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/female-web-designer-office-with-notebook_23-2149749870.jpg?uid=R61343051&ga=GA1.1.1538958416.1730788905"
                        className="w-100"
                        alt="Mobile App Development"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppsDevelopment;
